import {Injectable} from '@angular/core';
import {deserialize, JsonApiParams, JsonApiResponse, serialize} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {TisaAuthHttpService} from '../tisa-auth-http.service';
import {HttpHeaders} from '@angular/common/http';
import {AuthApiClient} from '@tisa-group/models';

@Injectable()
export class ClientService {
  constructor(readonly http: TisaAuthHttpService) {}

  fetch(
    params?: JsonApiParams,
    token?: string,
  ): Observable<JsonApiResponse<AuthApiClient>> {
    const tisaToken = token ?? localStorage.getItem('TISA_TOKEN') ?? '';

    const headers = new HttpHeaders({
      authorization: tisaToken,
    });

    return this.http
      .get('/client', {
        headers,
        params,
      })
      .pipe(deserialize());
  }

  update(body: Partial<AuthApiClient>): Observable<JsonApiResponse<AuthApiClient>> {
    const tisaToken = localStorage.getItem('TISA_TOKEN') ?? '';

    const headers = new HttpHeaders({
      authorization: tisaToken,
    });

    return this.http
      .patch<JsonApiResponse<AuthApiClient>>(`/client`, serialize({stuff: body}), {
        headers,
      })
      .pipe(deserialize());
  }
}
